import { useGoToPathFactory, useScopedPathnameFactory } from '@retailer-platform/dashboard/routing'
import { type DomainRouteName } from '../../routing/routes'
import { type ContentTypes } from '../../integrationConfigurations'

export const useDomainScopedPathname = useScopedPathnameFactory<DomainRouteName>()
export const useDomainGoToPath = useGoToPathFactory<DomainRouteName>()

export const useGoToApprovalRequestDetails = (
  approvalRequestId: string,
  contentType: ContentTypes
) => {
  if (contentType === 'data_ingestion_column_maps') {
    return useDomainGoToPath('app-admin-data-ingestion-approval-request/show', {
      approvalRequestId,
    })
  }
  if (contentType === 'yoda_rules') {
    return useDomainGoToPath('app-admin-yoda-rules-approval-request/show', {
      approvalRequestId,
    })
  }
  if (contentType === 'fulfillment_events') {
    return useDomainGoToPath('app-admin-fulfillment-events-approval-request', {
      approvalRequestId,
    })
  }
  if (contentType === 'massops') {
    return useDomainGoToPath('app-admin-massops-approval-request', {
      approvalRequestId,
    })
  }
  return undefined
}
